<div class="wraper">
  <div class="overlay" *ngIf="showSpinner">
    <div class="spinner-wrapper">
      <app-spinner></app-spinner>
    </div>
  </div>
  <div><p></p></div>
  <div class="loaded-content" [class.blurred]="showSpinner">
    <p-table #reqlist [columns]="cols" [value]="requisitionExceptions" [lazy]="true" (onLazyLoad)="loadRequisitionExceptionsLazy($event)" [paginator]="true" styleClass="p-datatable-customers"
             [rows]="20" [totalRecords]="totalRecords" [loading]="loading">
      <ng-template pTemplate="caption" [style]="{'height':'30px !important'}">
        <div style="height: 30px; width: 100%">
          <span class="float-left">Requisition Exception List</span>
          <div class="float-right" style="margin-left: 20px;">
          </div>
          <div class="float-right">
            <input pInputText type="text" (keypress)="handleSearchKey($event, reqlist)" placeholder="Requisition Exception Search" />
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th [style]=" {'overflow-wrap':'break-word' }" *hasClaim="'Resolve_Edit'"></th>
          <th [style]=" {'overflow-wrap':'break-word' }" *ngFor="let col of columns" [pSortableColumn]="col.field">
            {{col.header}}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        </tr>
        <tr class="ng-star-inserted">
          <th>
            <!--button column-->
          </th>
          <th>
            <!--Accession-->
            <input pInputText type="text" (input)="reqlist.filter($event.target.value, 'Accession', 'startsWith')" placeholder="Search by Accession" style="width: 100%;">
          </th>
          <th>
            <!--Client-->
            <input pInputText type="text" (input)="reqlist.filter($event.target.value, 'ClientName', 'startsWith')" placeholder="Search by Client Name" style="width: 100%;">
          </th>
          <th>
            <!--Issue Description-->
            <input pInputText type="text" (input)="reqlist.filter($event.target.value, 'IssueDescription', 'Contains')" placeholder="Search by Issue Description" style="width: 100%;">
          </th>
          <th>
            <!--Assigned To-->
            <input pInputText type="text" (input)="reqlist.filter($event.target.value, 'AssignedTo', 'Contains')" placeholder="Search by Assigned To" style="width: 100%;">
          </th>
          <th>
          </th>
          <th>
            <!--Resolution Description-->
            <input pInputText type="text" (input)="reqlist.filter($event.target.value, 'ResolutionDescription', 'Contains')" placeholder="Search by Resolution Description" style="width: 100%;">
          </th>
          <th>
            <!--Resolved-->
            <input pInputText type="text" (input)="reqlist.filter($event.target.value, 'Resolved', 'Equals')" placeholder="Search by Resolved" style="width: 100%;">
          </th>
          <th>
            <!--Resolved By-->
            <input pInputText type="text" (input)="reqlist.filter($event.target.value, 'ResolvedBy', 'Contains')" placeholder="Search by Assigned To" style="width: 100%;">
          </th>
          <th>
            <!--Resolved Date-->
            <!--<input pInputText type="text" (input)="onActivityChange($event)" placeholder="Minimum" class="p-column-filter">-->
          </th>
          <!--<th>-->
          <!--Updated By-->
          <!--<input pInputText type="text" (input)="onActivityChange($event)" placeholder="Minimum" class="p-column-filter">-->
          <!--</th>
          <th>-->
          <!--Updated Date-->
          <!--<input pInputText type="text" (input)="onActivityChange($event)" placeholder="Minimum" class="p-column-filter">-->
          <!--</th>-->
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-i="rowIndex" let-columns="columns">
        <tr>
          <td [style]=" {'overflow-wrap':'break-word' }" *hasClaim="'Resolve_Edit'">
            <button *hasClaim="'Resolve_Edit'" title="Attempt to Resolve Exception" class="btn" (click)="attemptToResolveRequisitionExceptions(rowData['Accession'], rowData['Id'])" [disabled]="(rowData['ShowAttemptToResolveRequisitionExceptionsButton'] == false)" style="margin-right:5px;margin-left:5px"><i class="fa fa-exchange"></i></button>
            <button *hasClaim="'Resolve_Edit'" title="Reject Requisition" class="btn" (click)="rejectRequisition(rowData['Accession'], rowData['Id'])" [disabled]="true"><i class="fa fa-download"></i></button>
            <button *hasClaim="'Resolve_Edit'" title="Dismiss Exception for Rejected Requisition" class="btn" (click)="dismissRequisitionException(rowData['Accession'], rowData['Id'])" [disabled]="(rowData['ShowDismissRequisitionExceptionButton'] == false)" style="margin-right:5px;margin-left:5px"><i class="fa fa-times-circle"></i></button>
          </td>
          <td [style]=" {'overflow-wrap':'break-word' }" *ngFor="let col of columns" [ngSwitch]="col.field">
            <span *ngSwitchDefault [style]=" {'overflow':'hidden' }">{{rowData[col.field]}}</span>
            <span *ngSwitchCase="'AssignedDate'">
              {{rowData[col.field] | date:'MM/dd/yyyy'}}
            </span>
            <span *ngSwitchCase="'ResolvedDate'">
              {{rowData[col.field] | date:'MM/dd/yyyy'}}
            </span>
            <span *ngSwitchCase="'UpdatedDate'">
              {{rowData[col.field] | date:'MM/dd/yyyy'}}
            </span>
            <span *ngSwitchCase="'Resolved'">
              {{rowData[col.field] ? 'yes':'no'}}
            </span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
<p-toast>
</p-toast>
